import React, { useState } from 'react'
import Button from './Button'
import numeral from 'numeral'

const Calculator = () => {

    const [display, setDisplay] = useState("");
    const [firstNumber, setFirstNumber] = useState("")
    const [secondNumber, setSecondNumber] = useState("")
    const [operandSelected, setOperandSelected] = useState(false)
    const [disable, setDisable] = useState(false)
    const [counter, setCounter] = useState(0)

    const handleChangeDisplay = (e) => {
        
        if(counter >= 10) {

            setDisplay("Err Too Long")
            
        }else {

            setDisplay(display + e )
            setCounter(counter + 1)
        }
        
    }
    const handleOperator = (e) => { 

        if(counter >= 10) {

            setDisplay("Err Too Long")

        }else{

            setDisplay(display + e)
            setOperandSelected(true)
            setCounter(counter + 1)
            
        }  
    }
    const handleClear = () => {

        setFirstNumber("")
        setSecondNumber("")
        setOperandSelected(false)
        setDisplay("")
        setCounter(0)

    }

    const handleEquals = () => {

        try {
            const answer = handleCalculations(display)
            handleSettingResults(answer)
            
        } catch (error) {
           setDisplay("Err leading  0") 
        }        
        
    }
    
    const handleCalculations = (answer) => {

         return Function(`'use strict'; return (${answer})`)()
    }

    const handleSettingResults = (answer) => {

        setDisplay(numeral(answer).format('0.[000]')) 
        setFirstNumber(answer)
        setSecondNumber("")
        setDisable(false)
        setOperandSelected(false)
        setCounter(0)

    }

    return(
    <div className="calculator-wrapper">

        <div className="display">{display}</div>    

            <Button 
                handleChangeDisplay={handleChangeDisplay} 
                handleOperator={handleOperator} 
                handleEquals = {handleEquals}
                handleClear = {handleClear}
            />
          
      </div>
    )

}


export default Calculator